module.exports = __webpack_public_path__ + "static/media/Close.b256ef5f.svg";